<style>
    .v--modal-overlay .v--modal-box {
        top:50px !important;
        margin-bottom: 20px;
    }
</style>
<template>
    <div class="footer-area">
        <footer class="footer-container">
            <div class="row">
                <div class="col-md-6 pull-left">
                    {{ $t('global.client-name') }} <a href="#" @click="$modal.show('terms-and-conditions')" style="padding: 1px;">{{ $t('footer.terms') }}</a>
                </div>
                <div class="col-md-6 pull-right text-right">
                    <span>{{ $t('page.footer') }}</span>
                </div>
            </div>
        </footer>
        <Terms/>
    </div>

</template>

<script>
import Terms from '@/components/Terms'

    export default {
        name:'Footer',
        components:{
            Terms,
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue